module.exports = __webpack_public_path__ + "static/media/minus.a5be9146.svg";